import React from 'react';
import I18n from 'i18n-js';
import { RCBanner } from '@reverbdotcom/cadence/components';
import BrandedHighFiveIcon from '@reverbdotcom/cadence/images/brand/high-five-orange.svg';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';

const HELP_CENTER_ARTICLE_ID = '22671226454675';

const InformActBanner = () => {
  return (
    <RCBanner
      content={
        <Translate text="discovery.sellerDashboard.informActBanner.description">
          <CoreLink
            className="text-link"
            target="_blank"
            to={Paths.helpCenterArticlesUrl.expand({ articleId: HELP_CENTER_ARTICLE_ID })}
          >
            <Translate text="discovery.sellerDashboard.informActBanner.helpCenterLinkText" />
          </CoreLink>
        </Translate>
      }
      cta={
        <CoreLink to={Paths.coreIdentityVerification.expand({})}>
          <Translate text="discovery.sellerDashboard.informActBanner.buttonText" />
        </CoreLink>
      }
      image={BrandedHighFiveIcon}
      title={I18n.t('discovery.sellerDashboard.informActBanner.title')}
      theme="info"
    />
  );
};

export default InformActBanner;
